export default __webpack_public_path__ + "static/media/thumbnail_blog_18.e5197c7c.png";